export const rituales = [
  {
    categoria: "rituales",
    nombre: "Hechizo de  abundancia",  
    imagen: require("../img/abundancia.png"),
    descripcion: "Hechizo para atraer la abundancia y la prosperidad a tu vida.",
    precio: "15€",
  },
  {
    categoria: "rituales",
    nombre: "Hechizo de amor propio personalizado",
    imagen: require("../img/amorP.png"),
    descripcion: "Hechizo para mejorar el amor propio.",
    precio: "10€",

  },
  {
    categoria: "rituales",
    nombre: "Hechizo de protección",
    imagen: require("../img/prote.png"),
    descripcion: "Hechizo para protegerte de energías negativas.",
    precio: "20€",
  },
  {
    categoria: "rituales",
    nombre: "LImpieza energética basica",
    imagen: require("../img/limpieza.png"),
    descripcion: "Limpiar tus energías.",
    precio: "25€",
  },
    {
    categoria: "rituales",
    nombre: "Ritual de tumbatrabajos",
    imagen: require("../img/tumbatrabajos.png"),
    descripcion: "Consta de dos partes, una tumba el trabajo y otra es de limpieza de restos",
    precio: "40€",
  },
  {
        categoria: "rituales",
        nombre: "Ritual para encontrar el amor",
        imagen: require("../img/amorNuevo.png"),
        descripcion: "Ritual para atraer nuevas oportunidades amorosas.",
        precio: "12€",
},
    {
        categoria: "rituales",
        nombre: "Ritual amarre",
        imagen: require("../img/amarre.png"),
        descripcion: "Ritual para fortalecer la conexión con tu pareja.",
        precio: "60€",
    },
    {
        categoria: "rituales",
        nombre: "Ritual de dominio",
        imagen: require("../img/dominioR.png"),
        descripcion: "Ritual para dominar la mente de otra persona.",
        precio: "40€",
    },
]